import { Routes } from '@angular/router';
import { authGuard, shopGuard, superadminGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard, superadminGuard],
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      {
        path: 'users',
        loadComponent: () => import('./features/admin/users/admin-users.component').then(m => m.AdminUsersComponent),
      },
      {
        path: 'categories',
        loadComponent: () => import('./features/admin/categories/admin-categories.component').then(m => m.AdminCategoriesComponent),
      },
      {
        path: 'import',
        loadComponent: () => import('./features/admin/import/excel-import.component').then(m => m.ExcelImportComponent),
      },
      {
        path: 'integrations',
        loadComponent: () => import('./features/admin/integrations/integration-overview.component').then(m => m.IntegrationOverviewComponent),
      },
      {
        path: 'docs',
        loadComponent: () => import('./features/admin/docs/admin-docs.component').then(m => m.AdminDocsComponent),
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./features/layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard, shopGuard],
    children: [
      { path: '', redirectTo: 'sale', pathMatch: 'full' },
      {
        path: 'sale',
        loadComponent: () => import('./features/sale/sale.component').then(m => m.SaleComponent),
      },
      {
        path: 'loan',
        loadComponent: () => import('./features/loan/loan.component').then(m => m.LoanComponent),
      },
      {
        path: 'pos',
        redirectTo: 'sale',
        pathMatch: 'full',
      },
      {
        path: 'entry',
        loadComponent: () => import('./features/inventory/add-item/add-item.component').then(m => m.AddItemComponent),
      },
      {
        path: 'search',
        loadComponent: () => import('./features/search/search.component').then(m => m.SearchComponent),
      },
      {
        path: 'inventory',
        loadComponent: () => import('./features/inventory/inventory-list/inventory-list.component').then(m => m.InventoryListComponent),
      },
      {
        path: 'smelting',
        loadComponent: () => import('./features/smelting/smelting.component').then(m => m.SmeltingComponent),
      },
      {
        path: 'bi',
        loadComponent: () => import('./features/bi/bi.component').then(m => m.BiComponent),
      },
      {
        path: 'transactions',
        loadComponent: () => import('./features/transactions/transactions.component').then(m => m.TransactionsComponent),
      },
      {
        path: 'clients',
        loadComponent: () => import('./features/clients/clients.component').then(m => m.ClientsComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
